import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: ${theme.layout.spacing(0, 3, 3)};
    gap: ${theme.layout.spacing(3)};
  `}
`;
